import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces'

export function useDialogSelector() {
    const dialog = useSelector((state: StateExtended) => state.dialog.dialog)
    return dialog
}
